import { render, staticRenderFns } from "./api_call_log_detail.vue?vue&type=template&id=97f525cc&scoped=true"
import script from "./api_call_log_detail.vue?vue&type=script&lang=js"
export * from "./api_call_log_detail.vue?vue&type=script&lang=js"
import style0 from "./api_call_log_detail.vue?vue&type=style&index=0&id=97f525cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f525cc",
  null
  
)

export default component.exports